import type { FacelessWorkflowPreset } from "@/content/seo/types";

export const FACELESS_PRESET_DURATIONS = [30, 60, 180, 300, 600] as const;
export const FACELESS_PRESET_ASPECT_RATIOS = ["9:16", "16:9"] as const;

type SearchParamReader = {
  get(name: string): string | null;
};

export function normalizeFacelessWorkflowPreset(
  input:
    | FacelessWorkflowPreset
    | ({
        aspectRatio?: unknown;
        planDuration?: unknown;
        storyType?: unknown;
      } & Record<string, unknown>),
): FacelessWorkflowPreset {
  const aspectRatio = String(input.aspectRatio || "");
  const planDuration = Number(input.planDuration);
  const storyType = String(input.storyType || "");
  const preset: FacelessWorkflowPreset = {};

  if (
    FACELESS_PRESET_ASPECT_RATIOS.includes(
      aspectRatio as (typeof FACELESS_PRESET_ASPECT_RATIOS)[number],
    )
  ) {
    preset.aspectRatio = aspectRatio as FacelessWorkflowPreset["aspectRatio"];
  }
  if (
    FACELESS_PRESET_DURATIONS.includes(
      planDuration as (typeof FACELESS_PRESET_DURATIONS)[number],
    )
  ) {
    preset.planDuration = planDuration as FacelessWorkflowPreset["planDuration"];
  }
  if (storyType === "url_to_video") preset.storyType = "url_to_video";

  return preset;
}

export function facelessWorkflowPresetFromSearchParams(
  searchParams: SearchParamReader,
) {
  return normalizeFacelessWorkflowPreset({
    aspectRatio: searchParams.get("preset_aspect_ratio"),
    planDuration: searchParams.get("preset_duration"),
    storyType: searchParams.get("preset_story_type"),
  });
}

export function appendFacelessWorkflowPreset(
  query: URLSearchParams,
  preset?: FacelessWorkflowPreset,
) {
  const normalized = normalizeFacelessWorkflowPreset(preset || {});
  if (normalized.aspectRatio) {
    query.set("preset_aspect_ratio", normalized.aspectRatio);
  }
  if (normalized.planDuration) {
    query.set("preset_duration", String(normalized.planDuration));
  }
  if (normalized.storyType) {
    query.set("preset_story_type", normalized.storyType);
  }
  return query;
}

export function appendFacelessWorkflowPresetToPath(
  path: string,
  preset?: FacelessWorkflowPreset,
) {
  const parsed = new URL(path, "https://ariaflow.local");
  appendFacelessWorkflowPreset(parsed.searchParams, preset);
  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
